import Vue from 'vue';
import VueRouter from 'vue-router';
import AppRoutes from './routes';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import usePostHog from '@/composables/posthog';

Vue.use(VueRouter, BootstrapVue, IconsPlugin);

const router = new VueRouter({
	mode: 'history',
	base: process.env.VUE_APP_PUBLIC_PATH || '/',
	routes: AppRoutes,

	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
			return { x: 0, y: 0 };
		}
	},
});

const { posthog } = usePostHog();

router.afterEach((to, from) => {
	posthog.capture('$pageview', {
		path: to.path,
		fullPath: to.fullPath,
		name: to.name,
		from: from.fullPath,
		query: to.query,
		params: to.params,
	});
});

export default router;
